<template>
  <div class="diagramContainer">
    <div class="drawerHeader">
      <span v-if="selectedDrawer">{{ selectedDrawer.dr_label ? selectedDrawer.dr_label : selectedDrawer.dr_id }}</span>
      <div class="drawer-header-buttons-container" :class="{ 'no-save-button': !showSaveButton }">
        <v-tooltip
          left
        >
          <template v-slot:activator="{on}">
            <v-btn
              v-on="on"
              icon
              class="drawer-button"
              :height="'24px'"
              :width="'24px'"
              @click="$emit('open-cassette-form')"
            >
              <v-icon size="18" color="white">add</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Add') + ' ' + $t('Cassette') }}</span>
        </v-tooltip>

        <v-tooltip
          left
        >
          <template v-slot:activator="{on}">
            <v-btn
              v-if="showSaveButton"
              v-on="on"
              icon
              class="drawer-button"
              :height="'24px'"
              :width="'24px'"
              :disabled="!connectionsWereChanged"
              @click="$emit('save-changes')"
            >
              <v-icon size="18" color="white">save</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('SaveChanges') }}</span>
        </v-tooltip>
      </div>
    </div>
    <div class="drawerOuterContainer">
      <drawer
        v-if="selectedDrawer || cassettes"
        :selected-drawer="selectedDrawer"
        :connections="connections"
        :cassettes="cassettes"
        @open-tray-connection-menu="openTrayConnectionMenu"
        @open-tube-form="openTubeForm"
        @open-cassette-form="$emit('open-cassette-form', $event)"
        @open-delete-cassette-dialog="$emit('open-delete-cassette-dialog', $event)"
      />
      <span v-else class="selectDrawerMessage">Please select a drawer</span>
    </div>
  </div>
</template>

<script>
import Drawer from "./Drawer.vue";

export default {
    name: "SelectedDrawer",

    components: {
      Drawer
    },

    props: {
      selectedDrawer: {
        type: Object,
        required: false,
      },

      connections: {
        type: Array,
      },

      cassettes: {
        type: Array,
        default: null,
      },

      connectionsWereChanged: {
        type: Boolean,
      },

      showSaveButton: {
        type: Boolean,
        default: true,
      },
    },

    methods: {
      /**
       * Emits an event to open the menu
       *
       * @param {Number} horizontal the horizontal coordinates
       * @param {Number} vertical the vertical coordinates
       * @param {String} fiberId the id of the fiber to be added
       * @param {String} side the side of the clicked connection
       */
      openTrayConnectionMenu(horizontal, vertical, fiberId, side) {
        this.$emit("open-tray-connection-menu", horizontal, vertical, fiberId, side)
      },

      /**
       * Emits an event to open the form
       *
       * @param {String} connectionSide the side of the clicked connection
       * @param {Object} cassette the data of the selected cassette
       * @param {Number} leftoverCapacity the leftover capacity of the cassette
       * @param {String} connectionId the id of the clicked connection
       */
      openTubeForm(connectionSide, cassette, leftoverCapacity, cassetteCapacity, positionInCassette, connectionId = null) {
        this.$emit("open-tube-form", connectionSide, cassette, leftoverCapacity, cassetteCapacity, positionInCassette, connectionId)
      }
    }
  }
</script>

<style scoped>
.diagramContainer{
  background-color: #eae7e7;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}
.drawerOuterContainer{
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  gap: 100px;
  padding-bottom: 10px;
  justify-content: center;
}
.selectDrawerMessage {
  margin: 0 auto;
  color: #4fa2b7;
  font-weight: 800;
  text-decoration: underline #4fa2b77b 15%;
  margin-top: 40%;
}
.drawerHeader {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  padding: 8px 0px;
  background-color: #4fa2b7 ;
  color: white;
  line-height: 25px;
}

.drawer-button {
  max-width: 24px;
}

.drawer-header-buttons-container {
  position: absolute;
  right: 49px;
  top: 39px;
}

.no-save-button {
  top: 8px;
  right: 18px;
}

.v-tooltip__content {
  border-radius: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/SelectedDrawer.vue